module.exports = __webpack_public_path__ + "img/premiation-4-airfry.7250f626.png";